<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p v-if="duplicate" class="modal-card-title">
          Duplicate Task
        </p>
        <p v-else class="modal-card-title">
          {{ toDo ? 'Update Task' : 'Add Task' }}
        </p>
      </header>
      <section class="modal-card-body">
        <p v-if="duplicate" class="modal-card-title my-3">
          This Task will be duplicated and assigned to everyone the parent assignment is assigned to.
        </p>
        <d-field label="Name*">
          <d-input v-model="todoForm.name" :required="true" />
        </d-field>
        <d-field label="Start Date (optional)">
          <div class="flex items-center">
            <div class="flex-shrink">
              <d-datepicker v-model="todoForm.startDate" icon="calendar" :required="false" />
            </div>
            <a v-if="todoForm.startDate" class="ml-2 cursor-pointer" @click="todoForm.startDate=null">clear</a>
          </div>
        </d-field>

        <d-field label="Due Date*">
          <d-datepicker v-model="todoForm.dueDate" icon="calendar" :required="true" />
        </d-field>
        <d-field label="Pre-Requisite Task">
          <div class="pt-2 relative mx-auto text-gray-600">
            <d-autocomplete
              v-model="todoForm.preRequisiteWorkItemId"
              open-on-focus
              :data="availablePreReqToDos"
              placeholder="Select a PreRequisite Task..."
              field="name"
            />
          </div>
          <template slot="empty">
            No results found
          </template>
        </d-field>
        <d-field label="Content">
          <vue-editor v-model="todoForm.htmlContent" :editor-toolbar="customToolbar" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ toDo ? 'Update Task' : 'Add Task' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>

  import axios from 'axios';

  export default {
    props: {
      toDo: {
        type: Object,
        default: () => { },
      },
      assignment: {
        type: Object,
        default: () => { },
      },
      duplicate: {
        type: Boolean,
        default: () => false,
      },
    },
    data: () => ({
      saving: false,
      searchPreRequisiteToDoValue: null,
      availablePreReqToDos: [],
      isFetching: false,
      todoForm: {
        name: '',
        htmlContent: '',
        dueDate: null,
        startDate: null,
        preRequisiteWorkItemId: null,
        assignmentTemplateId: 0,
      },
      customToolbar: [
        [{ header: [false, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['blockquote', 'code-block'],
        [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['clean'],
        ['link'],
      ],
    }),
    mounted() {
      this.getPreReqToDos();
      if (this.toDo) {
        this.todoForm = JSON.parse(JSON.stringify(this.toDo));
        if (this.duplicate) {
          this.todoForm.name = `${this.todoForm.name} COPY`;
        }
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.toDo) {
            await axios.patch(`/api/admin/todo-items/${this.todoForm.id}?duplicate=${this.duplicate}`, this.todoForm);
          } else {
            this.todoForm.assignmentTemplateId = this.assignment.id;
            await axios.post('/api/admin/todo-items/', this.todoForm);
          }
          this.$toast.open({ message: 'Save successful!', color: 'green-500', duration: 4000 });

          await this.$parent.events.getToDoItemsByAssignmentId();
          this.$parent.close();
        } catch (error) {
          this.$toast.error(error.response.data[0]);
        } finally {
          this.saving = false;
        }
      },

      async getPreReqToDos() {
        this.isFetching = true;
        try {
          const { data } = await axios.get(`/api/admin/assignment/todo-items/paged?currentPage=1&pageSize=1000&assignmentTemplateId=${this.assignment.id}`);
          if (this.toDo) {
            if (!this.duplicate) {
              this.availablePreReqToDos = data.resultItems.filter((x) => x.id !== this.toDo.id);
            } else {
              this.availablePreReqToDos = data.resultItems;
            }
          } else {
            this.availablePreReqToDos = data.resultItems;
          }
        } catch (error) {
          this.availablePreReqToDos = [];
          throw error;
        } finally {
          this.isFetching = false;
        }
      },

    },

  };
</script>